/**
 * Normaliza la respuesta de la API a la hora de guardar.
 *
 * El backend del CMDB no responde igual en todos los endpoints: la mayoría
 * devuelve `{ data: { …registro } }`, unos pocos el registro pelado y otros
 * `{ success: true, id: … }`. Los formularios necesitan el registro recién
 * creado para quedarse abiertos en modo edición (y para que el listado lo
 * adopte), así que se saca de aquí en vez de repetir la adivinanza en cada uno.
 *
 * Devuelve `null` si la respuesta no trae ningún registro identificable.
 */
export function registroGuardado(respuesta) {
  if (!respuesta || typeof respuesta !== 'object') return null;
  // Registro pelado.
  if (respuesta.id) return respuesta;
  // `{ data: registro }`
  if (respuesta.data && typeof respuesta.data === 'object' && respuesta.data.id) {
    return respuesta.data;
  }
  // `{ registro: {...} }` (algunos endpoints antiguos)
  if (respuesta.registro && typeof respuesta.registro === 'object' && respuesta.registro.id) {
    return respuesta.registro;
  }
  return null;
}
